let fiberSwiper = null;

function initFiberSwiper() {
  const isMobile = window.innerWidth <= 768;

  if (isMobile && !fiberSwiper && typeof Swiper !== 'undefined') {
    fiberSwiper = new Swiper('.fiber-cards.swiper', {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: true,
      pagination: {
        el: '.fiber-cards .swiper-pagination',
        clickable: true,
      },
    });
  }

  if (!isMobile && fiberSwiper) {
    fiberSwiper.destroy(true, true);
    fiberSwiper = null;
  }
}

document.addEventListener('DOMContentLoaded', initFiberSwiper);
window.addEventListener('resize', initFiberSwiper);

// Card toggle
document.addEventListener('click', function (e) {
  const toggle = e.target.closest('[data-toggle]');
  const togglePlus = toggle?.querySelector(".fiber-toggle-plus");
  const toggleMinus = toggle?.querySelector(".fiber-toggle-minus");
  if (!toggle) return;

  const card = toggle.closest('[data-card]');
  card.classList.toggle('active');
  if (card.classList.contains('active')){
    toggleMinus?.classList.remove("hidden");
    togglePlus?.classList.add("hidden")
  }else {
    toggleMinus?.classList.add("hidden");
    togglePlus?.classList.remove("hidden")
  }
});
